var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenu2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 8,
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.77663 1.75338C4.2268 0.787015 2.43986 -0.358302 1.47766 0.106983C1.47766 0.106983 1.23711 0.178565 1.23711 0.536477C1.23711 0.894389 1.30584 6.26306 1.30584 6.26306C1.30584 6.33465 1.40893 6.44202 1.61512 6.44202C2.8866 6.37044 4.12371 6.97889 4.74227 7.58734L4.77663 1.75338Z",
    fill: "#8D8E92"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.824742 1.39546C0.652921 1.46704 0.4811 1.53863 0.309278 1.646C0.309278 1.646 0 1.82496 0 2.21866C0 2.57657 0.0687285 7.90946 0.0687285 7.90946C0.0687285 7.98104 0.206186 8.05262 0.4811 7.94525C1.71821 7.47996 2.8866 7.3368 3.78007 7.40838C3.12715 7.05047 2.30241 6.83572 1.61512 6.87151C1.27148 6.87151 0.893471 6.69256 0.859107 6.26306C0.859107 4.65246 0.824742 3.00607 0.824742 1.39546Z",
    fill: "#8D8E92"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25773 1.75338C5.7732 0.787015 7.56014 -0.358302 8.52234 0.106983C8.52234 0.106983 8.76289 0.178565 8.76289 0.536477C8.76289 0.894389 8.72852 6.26306 8.72852 6.26306C8.72852 6.33465 8.62543 6.44202 8.41924 6.44202C7.1134 6.37044 5.91065 6.97889 5.25773 7.58734V1.75338Z",
    fill: "#8D8E92"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.17526 1.39546C9.38144 1.46704 9.55326 1.53863 9.69072 1.646C9.69072 1.646 10 1.82496 10 2.21866C10 2.57657 9.93127 7.90946 9.93127 7.90946C9.93127 7.98104 9.79381 8.05262 9.5189 7.94525C8.31615 7.47996 7.14777 7.3368 6.2543 7.40838C6.90722 7.05047 7.69759 6.83572 8.38488 6.87151C8.72852 6.87151 9.14089 6.69256 9.14089 6.26306C9.14089 4.65246 9.17526 3.00607 9.17526 1.39546Z",
    fill: "#8D8E92"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu2);
export default __webpack_public_path__ + "static/media/menu2.02defa5fe71be146a26b2f4d1f29afa8.svg";
export { ForwardRef as ReactComponent };